namespace RioERP.Web.Enums {
    export enum EBookType {
        PhotocopySpiral = 1,
        HardBind = 2,
        Charts = 3
    }
    Serenity.Decorators.registerEnumType(EBookType, 'RioERP.Web.Enums.EBookType');
}
